// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum FeeType {
  ForeignPaymentCost = "FOREIGN_PAYMENT_COST",
  ChargeRefundFee = "CHARGE_REFUND_FEE",
  ForeignPaymentToSepaCountriesCost = "FOREIGN_PAYMENT_TO_SEPA_COUNTRIES_COST",
}
export default FeeType;
